import { SettingApi } from "lib/api";
import { ApiHelper, Http } from "lib/api/base";

import { ComponentTemplate } from "lib/data/model";

export class ComponentTemplateApi {

	public static getComponentTemplates = async (reusable: boolean): Promise<ComponentTemplate[]> => {

		// Get Base Url
		const baseUrl = SettingApi.getApiBaseUrl();

		// Check Base Url
		if (baseUrl) {

			// Configure Url
			let url: string;
			if (reusable) {
				url = `${baseUrl}/componentTemplate?reusable=${reusable}`;
			}
			else {
				url = `${baseUrl}/componentTemplate`;
			}

			// Make Request
			const response: Response = await Http.httpGet(url, undefined);

			// Check Response
			if (response.ok) {

				// Parse Response Body
				const componentTemplates: ComponentTemplate[] = await ApiHelper.parseResponseBody(response);

				// make additions to SectionTemplate to make it functional for our page(flatten requirement items)
				return componentTemplates;
			}

			// TODO: Handle Errors
		}

		// Return Nothing
		return [];
	}
}
